<template>
  <div class="markdown-editor">
    <v-container>
      <CollapsibleComponent :slots="[{slot:'markdownEditor', title:'MarkDownEditor' }]">
        
        <template v-slot:markdownEditor.button>
          <EditButton v-model="edit" />
        </template>

        <template v-slot:markdownEditor>

          <MarkdownEditor :edit="edit" v-model="md_model" />

        </template>
      </CollapsibleComponent>      
    </v-container>
  </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import CollapsibleComponent from "@/components/profile/CollapsibleComponent";
import EditButton from "@/components/buttons/EditButton";    
import MarkdownEditor from "@/components/form/MarkdownEditor";    

export default {

  name: 'MarkdownEditorView',
  components:{
    CollapsibleComponent,
    EditButton,
    MarkdownEditor
  },

  setup(){
    const md_model = ref('# Marked in Node.js\n\nRendered by **marked**.');    

    const edit = ref(false);

    return {edit, md_model};
  }

}
</script>

<style lang="scss" scoped>
</style>